import template from './template.html'

angular.module('contabilidad.polizas')
  .config(['$stateProvider', function ($stateProvider) {
    $stateProvider.state('contabilidad.polizas.facturacion', {
      url: '/facturacion?{fecha_inicio:date}&{fecha_fin:date}&{:ids_clientes}',
      data: {
        title: 'Ingresos - Provisión',
      },
      params: {
        ids_clientes: {array: true},
      },
      reloadOnSearch: false,
      resolve: {
        fechaInicio: function ($stateParams) {
          return $stateParams.fecha_inicio
        },
        fechaFin: function ($stateParams) {
          return $stateParams.fecha_fin
        },
        idsClientes: function ($stateParams) {
          return $stateParams.ids_clientes
        },
      },
      views: {
        '@contabilidad': {
          template: '<contabilidad-polizas-facturacion fecha-inicio="fechaInicio" fecha-fin="fechaFin" ids-clientes="idsClientes"/>',
          controller: function ($scope, fechaInicio, fechaFin, idsClientes) {
            $scope.fechaInicio = fechaInicio
            $scope.fechaFin = fechaFin
            $scope.idsClientes = idsClientes
          },
        },
      },
    })
  }])

angular.module('contabilidad.polizas')
  .component('contabilidadPolizasFacturacion', {
    controller: ContabilidadPolizasFacturacionComponent,
    template,
    bindings: {
      fechaInicio: '<',
      fechaFin: '<',
      idsClientes: '<',
    },
  })

function ContabilidadPolizasFacturacionComponent ($dialog, $location, $filter, $q, $catalogos, facturacionService) {
  var $ctrl = this

  $ctrl.$dialog = $dialog
  $ctrl.$location = $location
  $ctrl.$q = $q
  $ctrl.$catalogos = $catalogos
  $ctrl.facturacionService = facturacionService
  $ctrl.filterBy = $filter('filter')
  $ctrl.orderBy = $filter('orderBy')
  $ctrl.groupBy = $filter('groupBy')

  $ctrl.fechaInicio = undefined
  $ctrl.fechaFin = undefined
  $ctrl.idsClientes = undefined
  $ctrl.data = null
  $ctrl.empresas = []
  $ctrl.buscando = false
  $ctrl.opciones = {
    fecha_inicio: new Date(),
    fecha_fin: new Date(),
    ids_clientes: [],
  }

  this.$onChanges = function (changes) {
    if (changes.fechaInicio) {
      $ctrl.opciones.fecha_inicio = $ctrl.fechaInicio || new Date()
    }

    if (changes.fechaFin) {
      $ctrl.opciones.fecha_fin = $ctrl.fechaFin || new Date()
    }

    if (changes.idsClientes) {
      $ctrl.opciones.ids_clientes = Array.isArray($ctrl.idsClientes) ? $ctrl.idsClientes : []
    }
  }

  this.$onInit = function () {
    $ctrl.promise = $ctrl.$q.all([
      $ctrl.$catalogos.get('clientes')
        .then(function (data) {
          $ctrl.empresas = data.map(function (item) {
            return {id: item.ID_Cliente, nombre: item.Nombre}
          })
        }),
      $ctrl.cargar()
        .then(function (data) {
          $ctrl.data = data
        }),
    ])
  }

  this.buscar = function () {
    if ($ctrl.opciones.ids_clientes.length === 0) return

    $ctrl.$location.replace()
    $ctrl.$location.search({
      fecha_inicio: $ctrl.opciones.fecha_inicio.toYMD(),
      fecha_fin: $ctrl.opciones.fecha_fin.toYMD(),
      ids_clientes: $ctrl.opciones.ids_clientes,
    })

    $ctrl.cargar()
      .then(function (data) {
        $ctrl.data = data
      })
  }

  this.cargar = function () {
    if ($ctrl.buscando) return $q.when(null)
    if ($ctrl.opciones.ids_clientes.length === 0) return $q.when(null)

    $ctrl.buscando = true

    return $ctrl.facturacionService.obtenerInformacionFacturacion($ctrl.opciones.fecha_inicio, $ctrl.opciones.fecha_fin, $ctrl.opciones.ids_clientes)
      .then(function (response) {
        var data = $ctrl.orderBy(response.data, ['emisor.nombre', 'receptor.nombre', 'poliza.serie', 'poliza.folio'])
        data.forEach(function (item) {
          item.diferencia = item.poliza.transacciones.reduce(function (total, item) {
            return +(total + (item.importe * (item.naturaleza === 'C' ? 1 : -1))).toFixed(2)
          }, 0)
        })
        console.log(response.data)
        console.log(data)
        return data
      })
      .finally(function () {
        $ctrl.buscando = false
      })
  }

  this.exportar = function () {
    $ctrl.$dialog.show('contabilidad.polizas.exportar', {
      data: $ctrl.data,
      fecha_inicio: $ctrl.opciones.fecha_inicio,
      config: {
        fecha_inicio: $ctrl.opciones.fecha_inicio,
        fecha_fin: $ctrl.opciones.fecha_fin,
        clientes: $ctrl.empresas.filter(function (empresa) {
          return $ctrl.opciones.ids_clientes.includes(empresa.id)
        }),
        archivo: 'Facturacion' + $ctrl.opciones.fecha_inicio.toYMD(),
        tipo_poliza: 'facturacion',
      },
    })
  }
}



// WEBPACK FOOTER //
// ./src/contabilidad/polizas/components/facturacion/component.js